import React from 'react';
import { bool, shape, string } from 'prop-types';

const Cultivation = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.1006 11.2002C19.5975 11.2005 20 11.7378 20 12.4004C19.9999 13.0629 19.5974 13.6003 19.1006 13.6006C18.6036 13.6006 18.2003 13.063 18.2002 12.4004C18.2002 11.7376 18.6035 11.2002 19.1006 11.2002Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M23.7002 8.90039V15.7998L19.2002 19.7002L14.7002 15.7998V13.2998H12.2998C11.6998 13.2998 11.2998 12.8998 11.2998 12.2998C11.2998 11.6998 11.6998 11.2998 12.2998 11.2998H14.7002V8.90039L19.1006 5L23.7002 8.90039ZM16.6006 9.7998V14.9004L19.1006 17L21.6006 14.7998V9.7002L19.1006 7.59961L16.6006 9.7998Z" fill="currentColor" />
    <path d="M8 7.2002L6.5 8.5L5.5 7.59961L3 9.7998V14.9004L5.5 17L6.5 16.0996V16.2002L8 17.5L5.5 19.5996L1 15.7998V8.90039L5.5 5L8 7.2002Z" fill="currentColor" />
    <path d="M14.7998 7.2002L13.2998 8.5L12.2998 7.59961L9.7998 9.7998V14.9004L12.2998 17L13.2998 16.0996V16.2002L14.7998 17.5L12.2998 19.5996L7.7998 15.7998V13.2998H5.5C4.9 13.2998 4.5 12.8998 4.5 12.2998C4.5 11.6998 4.9 11.2998 5.5 11.2998H7.7998V8.90039L12.2998 5L14.7998 7.2002Z" fill="currentColor" />
  </svg>
);

Cultivation.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Cultivation;
